import { _axios } from "@/plugins/axios";
class OrganigramaService {
  async getOrganigrama() {
    return _axios.get("/organigrama").then((response: any) => {
      return response.data;
    });
  }
}

export default new OrganigramaService();
